// extracted by mini-css-extract-plugin
module.exports = {"content":"VerifySignee_content__BJNlN","resend":"VerifySignee_resend__CjHJt","disabled":"VerifySignee_disabled__rMx9g"};